<template>
  <div class="card-header">
    <div class="card-header-col card-col w15">
      <Checkbox v-if="disableSelectAll" disabled v-model="checkAll"/>
      <Checkbox v-else @change="$emit('selectAll', checkAll)"  v-model="checkAll"/>
    </div>
    <div class="card-header-col card-col wp10">
      DATE
    </div>
    <div class="card-header-col card-col wp15">
      ORDER NUMBER
    </div>
    <div class="card-header-col card-col wp10">
      SOURCE
    </div>
    <div class="card-header-col card-col wp10">
      DESTINATION
    </div>
    <div class="card-header-col card-col wp10">
      REASON
    </div>
    <div class="card-header-col card-col wp15">
      AMOUNT
    </div>
    <div class="card-header-col card-col wp10">
      STATUS
    </div>
  </div>
</template>

<script>
export default {
  props: {
    disableSelectAll: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      checkAll: false,
    };
  },
};
</script>
